import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";


export default function DeleteCourseDialog({
    course,
    onDeleted,
    onRedirect,
    minWidth = 150,
    className = "w-full",
    renderTrigger,
}) {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [confirmText, setConfirmText] = useState("")
    const { getToken } = useAuth()

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            if (!token) return
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            const response = await axios.delete(api_endpoint + `/course/${course.id}`, reqConfig)
            console.log('Deletion of course data successful', response.data)
            toast.success(`Course "${course.title}" deleted successfully!`)
            setOpen(false)
            if (onDeleted) onDeleted(course.id)
            if (onRedirect) onRedirect()
        } catch (error) {
            console.error("Error deleting course:", error)
            toast.error("Failed to delete course.");
        } finally {
            setLoading(false)
        }
    }

    const triggerProps = {
        open: () => setOpen(true),
        close: () => setOpen(false),
    };

    const triggerNode = renderTrigger ? (
        renderTrigger(triggerProps)
    ) : (
        <Button
            variant="outline"
            className={className}
            onClick={() => setOpen(true)}
        >
            Delete
        </Button>
    );

    return (
        <>
            {triggerNode}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="max-w-md h-auto">
                    <DialogHeader>
                        <DialogTitle className="font-heading">Delete Course</DialogTitle>
                    </DialogHeader>
                    <div className="font-body">
                        Are you sure you want to delete the course <b>"{course.title}"</b>? This action cannot be undone.
                        <div className="mt-3 text-(--color-primary) font-bold">
                            Warning: Deleting this course will permanently remove all course content, student enrollments, and associated data.<br />
                            Please ensure you have re-assigned or informed all affected students before proceeding.
                        </div>
                        <div className="mt-4">
                            <label className="font-body text-sm">
                                Type <b>{course.title}</b> to confirm:
                            </label>
                            <input
                                type="text"
                                value={confirmText}
                                onChange={e => setConfirmText(e.target.value)}
                                className="border rounded px-2 py-1 w-full mt-1"
                                placeholder={`Type "${course.title}"`}
                            />
                        </div>
                    </div>
                    <div className="mt-4 flex gap-2 justify-between">
                        <DialogClose asChild>
                            <Button variant="outline" onClick={() => setOpen(false)} disabled={loading} className="">
                                Cancel
                            </Button>
                        </DialogClose>
                        <Button
                            variant=""
                            onClick={handleDelete}
                            disabled={loading || confirmText !== course.title}
                            className={`font-body min-w-[${minWidth}px] flex items-center justify-center rounded-[8px]`}
                        >
                            {loading ? (
                                <span className="flex items-center justify-center w-full">
                                    <ClipLoader size={20} color="#fff" />
                                </span>
                            ) : (
                                "Delete Course"
                            )}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

